import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { CommonService } from "../../../services/common/common.service";
import { SettingsService } from "../../../services/settings/settings.service";
import { GlobalContext } from "../../../store";
import AddBranchContent from "../../../modules/settings/components/branch-management/add-branch-content/add-branch-content.component";
import UpdateBranchContent from "../../../modules/settings/components/branch-management/update-branch-content/update-branch-content.component";
import SettingsHead from "../../../modules/settings/shared/settings-head/settings-head.component";
import { Box } from "@material-ui/core";

export default function BranchManagementPage() {
  const { t } = useTranslation();
  const commonService: CommonService = new CommonService();
  const settingsService: SettingsService = new SettingsService();
  const { setBranches, setPageTitle } = useContext(GlobalContext);
  const [branchesUpdated, setBranchesUpdated] = useState(false);

  const setBranchAdded = () => {
    setBranchesUpdated(true);
    setTimeout(() => {
      setBranchesUpdated(false);
    }, 100);
  };

  async function getBranches() {
    const response = await settingsService.listAllBranches();
    setBranches(response);
  }

  useEffect(() => {
    setTimeout(() => {
      commonService.setTitle(t("PAGE_META_TITLES.BRANCH_MANAGEMENT"));
      setPageTitle(t("PAGE_META_TITLES.BRANCH_MANAGEMENT"));
    }, 500);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    getBranches();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [branchesUpdated]);

  return (
    <Box className="content">
      <SettingsHead
        title={t("PAGES_HEAD.SETTINGS.BRANCH_MANAGEMENT_TITLE")}
        subTitle={t("PAGES_HEAD.SETTINGS.BRANCH_MANAGEMENT_SUB_TITLE")}
      />

      <AddBranchContent onBranchesChange={() => setBranchAdded()} />
      <UpdateBranchContent />
    </Box>
  );
}
